import { render } from "./cartItem.vue?vue&type=template&id=0d583d22&ts=true"
import script from "./cartItem.vue?vue&type=script&lang=ts"
export * from "./cartItem.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__